import { Component, Input } from '@angular/core';
import { faDrawSquare, faMinus, faPlus, faRotateLeft, faRotateRight } from '@fortawesome/pro-duotone-svg-icons';
import { faArrowPointer } from '@fortawesome/pro-light-svg-icons';
import { ExtendedKeyboardEvent, Hotkey, HotkeysService } from 'angular2-hotkeys';
import Konva from 'konva';
import { EventEmitterService } from 'src/modules/shared/services/event-emitter.service';
import { ISmartCanvasLayer, ISmartCanvasOptions } from '../../../shared/models/interfaces/smart-canvas.interface';

@Component({
  selector: 'hcr-smart-canvas-controls',
  templateUrl: './smart-canvas-controls.component.html',
  styleUrls: ['./smart-canvas-controls.component.sass'],
})
export class SmartCanvasControlsComponent {
  @Input() konvaLayers: { [id: string]: ISmartCanvasLayer };
  @Input() konvaStage: Konva.Stage;
  @Input() smartCanvasOptions: ISmartCanvasOptions;

  public states: { [key: string]: boolean } = {
    splitWords: false,
  };

  public icons = {
    plus: faPlus,
    minus: faMinus,
    rotateLeft: faRotateLeft,
    rotateRight: faRotateRight,
    arrowPointer: faArrowPointer,
    drawSquare: faDrawSquare,
  };

  constructor(private _hotKeysService: HotkeysService, private _eventEmitter: EventEmitterService) {
    this._hotKeysService.add(
      new Hotkey(
        ['*'],
        (event: KeyboardEvent): ExtendedKeyboardEvent => {
          if (event.target['tagName'].toLowerCase() !== 'input') {
            this.rotateRight();
          }

          return event;
        },
        [],
        'Rotacionar imagens'
      )
    );

    this._hotKeysService.add(
      new Hotkey(
        ['plus'],
        (event: KeyboardEvent): ExtendedKeyboardEvent => {
          if (event.target['tagName'].toLowerCase() !== 'input') {
            this.zoomIn();
          }
          return event;
        },
        [],
        'Aumentar zoom'
      )
    );

    this._hotKeysService.add(
      new Hotkey(
        ['-'],
        (event: KeyboardEvent): ExtendedKeyboardEvent => {
          if (event.target['tagName'].toLowerCase() !== 'input') {
            this.zoomOut();
          }
          return event;
        },
        [],
        'Diminuir zoom'
      )
    );
  }

  public rotateRight(): void {
    this.konvaStage.rotation(this.konvaStage.rotation() + 90);
  }

  public rotateLeft(): void {
    this.konvaStage.rotation(this.konvaStage.rotation() - 90);
  }

  public zoomIn(): void {
    this.konvaStage.scaleX(this.konvaStage.scaleX() + 0.1);
    this.konvaStage.scaleY(this.konvaStage.scaleY() + 0.1);
  }

  public zoomOut(): void {
    this.konvaStage.scaleX(this.konvaStage.scaleX() - 0.1);
    this.konvaStage.scaleY(this.konvaStage.scaleY() - 0.1);
  }

  public changeSplitWords(): void {
    this._eventEmitter.get<boolean>('show-splitted-words').emit(this.states.splitWords);
  }
}
